import type {
  GroupMeetingTeacher,
  GroupMeetingTeacherDto,
} from "meetings/group-meeting/types";

/**
 * Mentor classes a teacher has no lessons in (percentage 0) are dropped, like
 * the legacy meetingStore.fetchTeachers did — they can never pass a threshold.
 */
export const groupMeetingTeacherFromDto = (
  dto: GroupMeetingTeacherDto,
): GroupMeetingTeacher => ({
  id: dto.teacher_id,
  shortage: dto.teacher_shortage,
  mentorClasses: dto.mentor_classes
    .filter(({ percentage }) => percentage > 0)
    .map(({ name, percentage }) => ({ name, percentage })),
});
